<template>
    <div>
        <vx-card class="p-4 mb-6">
            <div class="flex flex-wrap items-center justify-between mb-4">
                <div class="flex items-center">
                    <h4 style="margin-left: 10px">POD</h4>
                </div>
                <div class="flex items-center">
                    <!-- <vs-button
                        @click="confirmData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="check"
                    >Confirm</vs-button>
                    <vs-button
                        @click="cancelData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="cancel"
                    >Cancel</vs-button> -->
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="filterInit"
                    >Filter</vs-button>
                    <vs-button 
                        class="mb-4 md:mb-0 mr-1" 
                        icon="import_export" 
                        @click="exportExcel({ endpoint: 'transport/pod/export', filter: filter, name: 'export_report_pod' })"
                    >Export</vs-button>
                    <!-- <vs-button
                        @click="exportData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="import_export"
                    >Export</vs-button> -->
                    <!-- <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        icon="filter_list"
                        @click="popupActiveTrack = true"
                    >Track And Trace</vs-button> -->
                </div>
            </div>

        <div class="vx-row" id="my-collapse">
        <div class="vx-col w-full" style="min-height:720px; overflow-y: auto;">
            
             <vs-collapse type="margin" accordion>
                <vs-collapse-item :key="indextr" v-for="(tr, indextr) in manifest"  icon-pack="feather" icon-arrow="icon-chevrons-down">
                  <div slot="header">
                    <!-- <small> -->
                         <strong>{{ `Manifest `+ tr.id }} - Routed Orders ({{ tr.order_list.length }})</strong> {{'/ '+ tr.schedule_date +' - Trip : '+tr.trip +' / "'+tr.vehicle.vehicle_code+'" - Driver : '+tr.vehicle.driver+' - '+tr.vehicle_type.vehicle_type + ' - '+tr.transporter.transporter_code}}
                    <!-- </small> -->
                    <vs-button class="mr-1" icon="remove_red_eye" @click="viewManifest(tr.id)" size="small">View Manifest</vs-button>
                  </div>

                  <vs-table id="routedOrder" v-model="tr.selected" :data="tr.order_list" v-show="tr.order_list.length > 0" stripe multiple>

                    <template slot="thead">
                      <vs-th>ID</vs-th>
                      <vs-th>Reference</vs-th>
                      <vs-th>Outbound Delivery</vs-th>
                      <vs-th>Req. Del. Date</vs-th>
                      <vs-th>Origin Name</vs-th>
                      <!-- <vs-th>Origin Address</vs-th> -->
                      <vs-th>Origin Area</vs-th>
                      <vs-th>Destination Name</vs-th>
                      <!-- <vs-th>Destination Address</vs-th> -->
                      <vs-th>Destination Area</vs-th>
                      <vs-th>Quantity</vs-th>
                      <vs-th>Volume (M3)</vs-th>
                      <vs-th>Weight (M3)</vs-th>
                      <vs-th>POD Date</vs-th>
                      <vs-th>POD Code</vs-th>
                      <vs-th>POD Description</vs-th>
                      <vs-th>POD Submit Date</vs-th>
                      <vs-th>POD Remark</vs-th>
                      <vs-th>POD Attachment</vs-th>

                    </template>

                    <template slot-scope="{data}">
                       <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="tr.tro_id">
                             {{ tr.tro_id }}
                             <vs-button class="mr-1" icon="remove_red_eye" size="small" @click="viewPod(tr.tro_id)">View POD</vs-button>
                            </vs-td>
                            <vs-td :data="tr.transport_reference">
                              {{ tr.transport_reference }}
                            </vs-td>
                            <vs-td :data="tr.outbound_id">
                              {{ tr.outbound != null ? tr.outbound.outbound_reference : '' }}
                            </vs-td>
                            <vs-td :data="tr.req_del_date">
                              {{ tr.req_del_date }}
                            </vs-td>
                            <vs-td :data="tr.origin.id">
                              {{ tr.origin.name }}
                            </vs-td>
                         <!--    <vs-td :data="tr.origin.id">
                              {{ tr.origin.address_1 }}
                            </vs-td> -->
                            <vs-td :data="tr.origin_area.id">
                              {{ tr.origin_area.village }}
                            </vs-td>
                            <vs-td :data="tr.destination.id">
                              {{ tr.destination.name }}
                            </vs-td>
                       <!--      <vs-td :data="tr.destination.id">
                              {{ tr.destination.address_1 }}
                            </vs-td> -->
                            <vs-td :data="tr.destination_area.id">
                              {{ tr.destination_area.village }}
                            </vs-td>
                            <vs-td :data="tr.sum_qty">
                              {{ tr.sum_qty }}
                            </vs-td>
                            <vs-td :data="tr.base_volume">
                              {{ tr.base_volume }}
                            </vs-td>
                            <vs-td :data="tr.base_gw">
                              {{ tr.base_gw }}
                            </vs-td>
                            <vs-td :data="tr.pod.pod_time">
                              {{ tr.pod.pod_time }}
                            </vs-td>
                            <vs-td :data="tr.pod.pod_code">
                              {{ tr.pod.pod_code }}
                            </vs-td>
                            <vs-td :data="tr.pod.pod_description">
                              {{ tr.pod.pod_description }}
                            </vs-td>
                            <vs-td :data="tr.pod.pod_submit_time">
                              {{ tr.pod.pod_submit_time }}
                            </vs-td>
                            <vs-td :data="tr.pod.pod_remark">
                              {{ tr.pod.pod_remark }}
                            </vs-td>
                            <vs-td :data="tr.pod.pod_file">
                              <vs-button v-if="tr.pod.pod_file" class="mr-1" icon="attachment" size="small" @click="viewAttachment(tr.pod.pod_file)">{{ tr.pod.pod_file }}</vs-button>
                            </vs-td>
                          </vs-tr>
                    </template>

                  </vs-table>

                    <div class="flex flex-wrap items-center mt-4 mr-2">
                         <div class="flex">
                            <vs-button class="mr-1 xl:mb-0 lg:mb-1" icon="done" color="success" size="small" @click="confirmPod(tr)" :disabled="tr.selected.length <= 0">Confirm</vs-button>
                            <vs-button icon="cancel" color="warning" size="small" @click="cancelPod(tr)" :disabled="tr.selected.length <= 0">Cancel</vs-button>
                        </div>
                    </div>
                </vs-collapse-item>
              </vs-collapse>

        </div>
    </div>
    <vs-pagination :total="totalPages" v-model="currentPage" :max="7" class="mt-6 mb-0"></vs-pagination>
</vx-card>

<vs-popup :title="'Manifest '+single_manifest.id" :active.sync="showPopupManifest" id="myPopup">
    <div class="row pt-4 pb-4 px-4">
      <div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <!-- <vs-button class="btn mb-4 md:mb-0 mr-1" icon="edit" v-show="!editMode" @click="editManifest">Edit</vs-button> -->
                <vs-button color="warning" class="btn mb-4 md:mb-0 mr-1" icon="cancel" @click="discardManifest" v-show="editMode">Cancel</vs-button>
                <vs-button class="btn mb-4 md:mb-0 mr-1" icon="save" v-show="editMode" @click="updateManifest">Save</vs-button>
                <!-- <vs-dropdown vs-trigger-click class="mr-1">
                    <vs-button class="btn-drop" type="filled" icon="expand_more">Proccess</vs-button>
                    <vs-dropdown-menu>
                        <vs-dropdown-group vs-collapse vs-label="Batch Pick" vs-icon="add">
                            <vs-dropdown-item>
                                Create Picking
                            </vs-dropdown-item>
                            <vs-dropdown-item>
                                Confirm Picking
                            </vs-dropdown-item>
                            <vs-dropdown-item divider>
                                Print Batch Pick
                            </vs-dropdown-item>
                        </vs-dropdown-group>
                        <vs-dropdown-item divider>
                            Good Issue All DO
                        </vs-dropdown-item>
                        <vs-dropdown-item >
                            Confirm Manifest
                        </vs-dropdown-item>
                        <vs-dropdown-item :disabled="true">
                            Unconfirm Manifest
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
              </vs-dropdown> -->
                <vs-button class="mb-4 md:mb-0 mr-1" icon="remove_red_eye" @click="exportTransportNote" >Print</vs-button>
                
            </div>
      </div>
       <div class="vx-row pt-5">
          <div class="vx-col lg:w-1/3 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Manifest
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.id" class="w-full" disabled/>
                  </div>
              </div>
              <div class="vx-row mb-3 mt-1">
                  <div class="vx-col w-1/3">
                      Schedule Date
                  </div>
                  <div class="vx-col w-2/3">
                      <flat-pickr v-model="single_manifest.schedule_date" class="w-full" :disabled="!editMode"/>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Trip
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.trip" class="w-full" :disabled="!editMode"/>
                  </div>
              </div>
          </div>
          <div class="vx-col lg:w-1/3 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                     Reference
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.reference" class="w-full" :disabled="true"/>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Origin
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.origin_id" :options="areaOptions" label="village" @search="searchArea" :clearable="true" :disabled="!editMode"></v-select>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Destination
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.destination_id" :options="areaOptions" label="village" @search="searchArea" :clearable="true" :disabled="!editMode"></v-select>
                  </div>
              </div>
          </div>
          <div class="vx-col lg:w-1/3 w-full">

              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Status
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="single_manifest.status.name" class="w-full" :disabled="true"/>
                  </div>
              </div>
              
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Client ID
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.client_id" :options="clientOption" label="client_code" :clearable="false" :disabled="!editMode"></v-select>
                  </div>
              </div>
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Warehouse ID
                  </div>
                  <div class="vx-col w-2/3">
                      <v-select v-model="single_manifest.warehouse_id" :options="warehouseOptions" label="name" :clearable="true" :disabled="!editMode"></v-select>
                  </div>
              </div>
          </div>
      </div>

        <vs-tabs style="height:100%;" class="mt-8">
          <vs-tab label="Vehicle Summary">
            <div class="vx-row mt-4">
                <div class="vx-col lg:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Vehicle Master
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.vehicle_id" :options="vehicleOption" label="vehicle_code" @input="setVehicle()" :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Vehicle
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.alter_vehicle_id" :options="vehicleOption" label="vehicle_code"  @input="setAlterVehicle()"  :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Driver
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input  v-model="single_manifest.driver"  class="w-full" :disabled="!editMode"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Phone
                        </div>
                        <div class="vx-col w-2/3">
                            <vs-input  v-model="single_manifest.phone" class="w-full" :disabled="!editMode"/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Vehicle Type
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.vehicle_type_id" :options="vehicleTypeOption" label="vehicle_type" :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                            Transporter 
                        </div>
                        <div class="vx-col w-2/3">
                            <v-select v-model="single_manifest.transporter_id" :options="transporterOption" label="transporter_code" :clearable="false" :disabled="!editMode"></v-select>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Cap. Volume
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>M3</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.vehicle_id.cap_volume" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Cap. Weight
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>KG</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.vehicle_id.cap_weight" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Load Volume
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>M3</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.load_volume" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Load Weight
                        </div>
                        <div class="vx-col w-2/3">
                            <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>KG</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.load_weight" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                     <div class="vx-row mb-3">
                        <div class="vx-col w-1/3">
                           Load Quantity
                        </div>
                        <div class="vx-col w-2/3">
                             <vx-input-group>
                            <template slot="append">
                                <div class="append-text bg-primary">
                                <span>Unit</span>
                                </div>
                            </template>
                            <vs-input  v-model="single_manifest.load_quantity" class="w-full" :disabled="!editMode"/>
                            </vx-input-group>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/3 w-full">

                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Transporter Mode
                    </div>
                    <div class="vx-col w-2/3">
                        <v-select v-model="single_manifest.transporter_mode_id" :options="transporterModeOption" label="mode" :clearable="false" :disabled="!editMode"></v-select>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Container No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.container_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>
                   
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Seal No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.seal_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>
                   
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Vessel No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.vessel_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>
                   
                <div class="vx-row mb-3">
                    <div class="vx-col w-1/3">
                        Voyage No.
                    </div>
                    <div class="vx-col w-2/3">
                        <vs-input  v-model="single_manifest.voyage_number"  class="w-full" :disabled="!editMode"/>
                    </div>
                </div>


                </div>
            </div>
          </vs-tab>

          <vs-tab label="Picking Summary">
          </vs-tab>
          <vs-tab label="Tracking Summary">
          </vs-tab>
          <vs-tab label="Notes">
          </vs-tab>
          <vs-tab label="Attachment">
          </vs-tab>
        </vs-tabs>

        <vs-popup title="Close without Save ?" :active.sync="closePopupManifest">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
        </vs-popup>

    </div>
</vs-popup>

<vs-popup :title="'Transport Order '+tro.transport_reference" :active.sync="showPopupTro" id="myTropoppup">
    <div class="row pt-4 pb-4 px-4">
      <!--<div class="flex flex-wrap items-center justify-between mb-10">
            <div class="flex items-center">
                <vs-button color="warning" class="btn mb-4 md:mb-0 mr-1" icon="cancel" @click="discardPod" v-show="editMode">Cancel</vs-button>
            </div>
      </div>-->
      <div class="vx-row pt-5">
          <div class="vx-col lg:w-1/4 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      TRO
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.id" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Reference
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.transport_reference" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Req. Del. Date
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.req_del_date" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Transporter ID
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.transporter_name" class="w-full" disabled/>
                  </div>
              </div>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Outbound Reference
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.transport_reference" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Order Type
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.order_type" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Client
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.client_name" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Service Type ID
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.transporter_service_name" class="w-full" disabled/>
                  </div>
              </div>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Origin
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.origin_name" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Address
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.origin_address1" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3"></div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.origin_address2" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Origin Area
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.origin_area_name" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Origin Sub Area
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.origin_area_subdist" class="w-full" disabled/>
                  </div>
              </div>
          </div>
          <div class="vx-col lg:w-1/4 w-full">
              <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                      Destination
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.destination_name" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Address
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.destination_address1" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3"></div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.destination_address2" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Destination Area
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.destination_area_name" class="w-full" disabled/>
                  </div>
                  <div class="vx-col w-1/3">
                      Destination Sub Area
                  </div>
                  <div class="vx-col w-2/3">
                      <vs-input v-model="tro.destination_area_subdist" class="w-full" disabled/>
                  </div>
              </div>
          </div>
      </div>
      <vs-card class="p-4">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <h4>Transport Order Details</h4>
                    <!-- <vs-button @click="addItem()" class="btn mb-4 md:mb-0 mr-1" :disabled="data.transport_order.client != null ? false : true ">Add</vs-button> -->
                </div>
                <div style="overflow-y: auto;">
                    <table cellspacing="5">
                        <thead>
                            <tr>
                                <th style="width: 1%">Line ID</th>
                                <th style="width: 15%">Warehouse</th>
                                <th style="width: 15%">Product</th>
                                <th style="width: 10%">Description</th>
                                <th style="width: 5%">Pack ID</th>
                                <th style="width: 5%">Batch</th>
                                <th style="width: 10%">Exp. Date</th>
                                <th style="width: 5%">Qty</th>
                                <th style="width: 5%">UoM</th>
                                <th style="width: 10%">Stock Type</th>
                                <th style="width: 5%">Base Qty</th>
                                <th style="width: 5%">Base UoM</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail, index) in tro.transporter_order_detail" :key="index">
                                <td>
                                    <vs-input class="w-full" v-model="detail.line_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.warehouse_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.product_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.description" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.pack_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.batch" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.expired_date" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.qty" disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.uom_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.stock_type_id" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.base_qty" :disabled="true"/>
                                </td>
                                <td>
                                    <vs-input class="w-full" v-model="detail.base_uom_id" :disabled="true"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </vs-card>
        <vs-popup title="Close without Save ?" :active.sync="closePopupTro">
            <p>POD.</p>
        </vs-popup>

    </div>
</vs-popup>

<vs-popup :title="'Attachment'" :active.sync="showPopupAttachment" id="myAttachpoppup">
    <div class="row pt-4 pb-4 px-4">
      <div class="vx-row pt-5">
          <img v-if="attach_name" :src="$http.defaults.baseURL+'/upload/pod/'+attach_name" width="400px"/>
      </div>
        <vs-popup title="Close without Save ?" :active.sync="closePopupAttachment">
            <p></p>
        </vs-popup>

    </div>
</vs-popup>
<!-- start-confirm-pod -->
<vs-prompt @accept="submitPod" title="Confirm POD " :active.sync="showConfirmPod" @close="showConfirmPod = true" :accept-text="'Confirm'">
    <div class="con-exemple-prompt">
        <div class="vx-row mb-5 mt-2">
            <div class="vx-col w-1/3">
                Order Selected
            </div>
            <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="selectedOrderCount" :disabled="true"/>
            </div>
        </div>
        <div class="vx-row mb-4">
            <div class="vx-col w-full">
                 <vs-checkbox class="ml-0" v-model="data_confirm.enable_arrival">Arrival</vs-checkbox>
            </div>
        </div>
        <div class="vx-row mb-3">
            <div class="vx-col w-1/3">
            Time
            </div>
            <div class="vx-col w-2/3">
                <flat-pickr class="w-full" v-model="data_confirm.arrival_time" :config="configdateTimePicker" :disabled="!data_confirm.enable_arrival"/>
            </div>
        </div>
        <div class="vx-row mb-4">
            <div class="vx-col w-1/3">
            Receiver Name
            </div>
            <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="data_confirm.receiver_name" :disabled="!data_confirm.enable_arrival"/>
            </div>
        </div>
        <div class="vx-row mb-3">
            <div class="vx-col w-full">
                 <vs-checkbox class="ml-0" v-model="data_confirm.enable_pod">POD</vs-checkbox>
            </div>
        </div>
        <div class="vx-row mb-3">
            <div class="vx-col w-1/3">
            Time
            </div>
            <div class="vx-col w-2/3">
             <flat-pickr class="w-full" v-model="data_confirm.pod_time" :config="configdateTimePicker" :disabled="!data_confirm.enable_pod"/>
            </div>
        </div>
        <div class="vx-row mb-4">
            <div class="vx-col w-1/3">
            POD Code
            </div>
            <div class="vx-col w-2/3">
                <v-select v-model="data_confirm.pod_code_id" :reduce="pod_code => pod_code.id" :options="podCodeOption" label="pod_code" :disabled="!data_confirm.enable_pod"></v-select>
            </div>
        </div>
        <div class="vx-row mb-3">
            <div class="vx-col w-full">
            </div>
        </div>
        <div class="vx-row mb-5">
            <div class="vx-col w-2/4">
                 <vs-checkbox class="ml-0" v-model="data_confirm.enable_submit_time">Submit Time</vs-checkbox>
            </div>
            <div class="vx-col w-2/3">
             <flat-pickr class="w-full ml-6" v-model="data_confirm.submit_time" :config="configdateTimePicker" :disabled="!data_confirm.enable_submit_time"/>
            </div>
        </div>
        <div class="vx-row mb-3">
            <div class="vx-col w-1/3">
                 <vs-checkbox class="ml-0" v-model="data_confirm.enable_remark">Remark</vs-checkbox>
            </div>
            <div class="vx-col w-2/3">
                <vs-input class="w-full" v-model="data_confirm.remark" :disabled="!data_confirm.enable_remark"/>
            </div>
        </div>
        <div class="vx-row mb-3">
            <div class="vx-col w-1/3">
                 Attach file
            </div>
            <input 
              type="file" 
              id="pod_file"
              v-on:change="handleFileUpload($event)"
            />
        </div>
    </div>
</vs-prompt>
<!-- end-confirm-pod -->

<!-- start-filter -->
<vs-prompt @accept="filterData" title="Filter" :active.sync="showFilter">
    <div class="con-exemple-prompt">
                <vs-input v-model="filter.manifest_id" class="mb-2 w-full" label="Manifest ID" />
                
                <!-- <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.supplier_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_client)"
                >
                    <vs-select-item v-for="(item, index) in ddl_client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select> -->

                <label class="vs-input--label">Schedule Date</label>
                <vs-row vs-w="12" vs-justify="space-between" class="mb-2">
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="5" style="padding-left: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.schedule_date_start" />
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="2">To</vs-col>
                    <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="5" style="padding-right: 0">
                        <flat-pickr class="vx-col w-full p-2" v-model="filter.schedule_date_end" />
                    </vs-col>
                </vs-row>

                <vs-input v-model="filter.trip" class="mb-2 w-full" label="Trip" />

                <label class="vs-input--label">Vehicle ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.vehicle_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_vehicle)"
                >
                    <vs-select-item v-for="(item, index) in ddl_vehicle.data" :key="index" :value="item.id" :text="item.vehicle_code"/>
                </vs-select>

                <label class="vs-input--label">Status POD</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.pod_code_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_podcodes)"
                >
                    <vs-select-item v-for="(item, index) in ddl_podcodes.data" :key="index" :value="item.id" :text="item.pod_code"/>
                </vs-select>

                  <vs-input v-model="filter.inbound_reference" class="mb-2 w-full" label="Out. Delivery" />
                  <vs-input v-model="filter.inbound_reference" class="mb-2 w-full" label="DO Reference" />


                <label class="vs-input--label">Transporter ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.transporter_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_transporter)"
                >
                    <vs-select-item v-for="(item, index) in ddl_transporter.data" :key="index" :value="item.id" :text="item.transporter_code"/>
                </vs-select>

                <label class="vs-input--label">Origin ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.origin_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_origin)"
                >
                    <vs-select-item v-for="(item, index) in ddl_origin.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
                
                 <label class="vs-input--label">Destination ID</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.destination_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_destination)"
                >
                    <vs-select-item v-for="(item, index) in ddl_destination.data" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>

            </div>
</vs-prompt>
<!-- end-filter -->

<!-- start-track-and-trace -->
<vs-popup title="AWB Track and Trace" :active.sync="popupActiveTrack">

    <div class="vx-row mb-4">
        <div class="vx-col w-1/4">
            AWB Number
        </div>
        <div class="vx-col w-1/2">
            <vs-input v-model="track.awb"/>
        <!-- <vx-input-group>
            <template slot="append">
            </template>
        </vx-input-group> -->
        </div>
    </div>
    <div class="vx-row">
        <div class="vx-col w-1/4">
        </div>
        <div class="vx-col w-1/2">
            <vs-button @click="submitTrackAndTrace" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Submit</vs-button>
        </div>
    </div>

    <vs-divider icon-pack="feather" position="center">Details</vs-divider>



</vs-popup>
<!-- end-track-and-trace -->
</div>
</template>

<script>
import vSelect from "vue-select";
import FileSaver from "file-saver";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
    },
    data() {
        return {
            file: '',
            popupActiveTrack:false,
            track:{
                awb:''
            },
            searchQuery: "",
            gridOptions: {},
            
            manifest: [],
            showConfirmPod:false,
            editMode:false,
            data_confirm:{
                enable_arrival:true,
                arrival_time:null,
                receiver_name:'',
                enable_pod:true,
                pod_code_id:null,
                pod_time:null,
                enable_submit_time:true,
                submit_time:null,
                enable_remark:true,
                remark:'',
            },
            selectedOrder:[],

            selectedOrderCount:0,

            maxPageNumbers: 7,
            gridApi: null,
            isLoading: false,
            maxRetry: 10,
            showFilter: false,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            configdateTimePicker: {
                enableTime: true,
                dateFormat: 'd-m-Y H:i'
            },
            podCodeOption:[],
            masterSync:false,
            filter: {
                manifest_id: "",
                client_id: null,
                schedule_date_start: null,
                schedule_date_end: null,
                trip: '',
                transporter_id: null,
                origin_id: null,
                destination_id: null,
                vehicle_id:null,
            },
            //  this.$http.post('master/clients'), 
            //     this.$http.post("master/areas"),
            //     this.$http.post("master/transporters"),
            //     this.$http.post("master/vehicle"),
            //     this.$http.post("master/warehouses"),       
            //     this.$http.post("master/vehicletypes"),
            //     this.$http.post("master/contracttypes"),
            //     this.$http.post("master/transportersmode"),
            ddl_client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            ddl_transporter: {
                data: [],
                loading: false,
                endpoint: 'master/transporters',
                objectKey: 'transporter_code'
            },
            ddl_vehicle: {
                data: [],
                loading: false,
                endpoint: 'master/vehicle',
                objectKey: 'vehicle_code'
            },
            ddl_podcodes: {
                data: [],
                loading: false,
                endpoint: 'master/podcodes',
                objectKey: 'pod_code'
            },
            ddl_origin: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            ddl_destination: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            ddl_customer: {
                data: [],
                loading: false,
                endpoint: 'master/customers',
                objectKey: 'name'
            },
            
            showPopupManifest:false,
            showPopupTro:false,
            showPopupAttachment:false,
            closePopupManifest:false,
            closePopupTro:false,
            closePopupAttachment:false,
            // show-edit-manifest
            single_manifest : {
                id:'',
                trip:'',
                schedule_date:'',
                reference:'',
                origin_id:null,
                destination_id:null,
                status:{
                    id:'',
                    name:''},
                client_id:null,
                warehouse_id:null,
                driver:'',
                phone:'',
                vehicle_id:{
                    box_dimension: '',
                    cap_volume: '',
                    cap_weight: '',
                    contract_type_id: null,
                    driver: '',
                    phone: '',
                    transporter_id: null,
                    vehicle_code: '',
                    vehicle_type_id: null,

                },
                load_volume:'',
                load_weight:'',
                load_quantity:'',
                alter_vehicle_id:null,
                transporter_id: null,
                vehicle_type_id:null,
                transporter_mode_id:null,
                container_number:'',
                seal_number:'',
                vessel_number:'',
                voyage_number:'',
            },
            attach_name:'',
            tro : {
                id:'',
                transport_reference:'',
                req_del_date:'',
                order_type: '',
                client_name: '',
                origin_name: '',
                origin_address1: '',
                origin_address2: '',
                origin_area_name: '',
                origin_area_subdist: '',
                destination_address1: '',
                destination_address2: '',
                destination_area_name: '',
                destination_area_subdist: '',
                transporter_name: '',
                transporter_service_name: '',
                transporter_order_details:[],
            },
            // end-show-edit-tro
            areaOptions: [],
            warehouseOptions:[],
            vehicleOption:[],
            transporterOption:[],
            clientOption:[],
            vehicleTypeOption:[],
            contractTypeOption:[],
            transporterModeOption:[],
            
            
            // pagination
            totalPages: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
        };
    },
    computed: {
        // paginationPageSize() {
        //     if (this.gridApi) return this.gridApi.paginationGetPageSize();
        //     else return 50;
        // },
        // totalPages() {
        //     if (this.gridApi) return this.gridApi.paginationGetTotalPages();
        //     else return 0;
        // },
        // currentPage: {
        //     get() {
        //         if (this.gridApi)
        //             return this.gridApi.paginationGetCurrentPage() + 1;
        //         else return 1;
        //     },
        //     set(val) {
        //         this.gridApi.paginationGoToPage(val - 1);
        //     }
        // }
    },
    watch: {
        showPopupManifest:function(){
            if(this.editMode){
            //     this.$vs.dialog({
            //     type: 'confirm',
            //     color: 'warning',
            //     title: 'Close tab without save ?',
            //     text: 'Your changes will lose ?',
            //     accept: function() {
            //         this.editMode = false ;
            //         this.showManifestPopup = false;
            //     },
            //     cancel: function() {
            //         }
            // })

            this.editMode = true ;
            this.showPopupManifest = true;
            // this.closePopupManifest = true ;
            }
        },
        showPopupTro:function(){
            if(this.editMode){
            
            this.editMode = true ;
            this.showPopupTro = true;
            // this.closePopupManifest = true ;
            }
        },
        showPopupAttachment:function(){
            if(this.editMode){
            
            this.editMode = true ;
            this.showPopupAttachment = true;
            // this.closePopupManifest = true ;
            }
        },
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage:function() {
          this.requestPaginate(this.currentPage)
        },
    },
    methods: {
        requestPaginate(number){
             this.isLoading = true;
             this.$http.post("transport/pod?page="+number, this.filter)
             .then((res)=>{
                 this.manifest = []
                let count = res.data.total / res.data.per_page ;
                    this.totalPages = count ;
                    res.data.data.map(item => {
                        this.manifest.push({...item, selected:[]})
                    });
                    this.isLoading = false;
             })
             .catch((error)=>{
                this.isLoading = false;
                this.manifest = []
             })
        },
        submitTrackAndTrace(){
            this.isLoading = true ;
            this.$http.post('transport/pod/track-and-trace', {awb:this.track.awb})
            .then((resp) => {
                
                this.isLoading = false ;
            })
            .catch((error) =>{
                console.log(error)
                this.isLoading = false ;
            })
        },
        handleFileUpload(event){
          this.file = event.target.files[0];
        },
        submitPod(){
             /*for (const [index, item] of this.selectedOrder.entries()) {
                let data = {
                  ...this.data_confirm,
                  tro_id:item.tro_id,
                }
                this.$http.post('transport/pod/update-pod', data)
                .then((resp)=>{
                //   console.log(resp)
                    this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: resp.data.message
                  })
                })
                .catch((error) => {
                    for (const [index, error] of error.response.data.message.entries()){
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: error
                        })
                    }
                })
             }*/

             let file = new FormData();
              file.append("pod_file",this.file);
              let data = {};

              for (const [index, item] of this.selectedOrder.entries()) {

                data = {
                  ...this.data_confirm,
                  tro_id:item.tro_id,
                }
                
              }

            this.$http.post('transport/pod/update-pod', file,{
              headers: {
                  "Content-Type": "multipart/form-data"
              },

              params: data
            })
            .then((resp)=>{
            //   console.log(resp)
                this.$vs.notify({
                color: 'success',
                title: 'Success',
                iconPack: 'feather',
                icon:'icon-x',
                text: resp.data.message
              })
            })
            .catch((error) => {
              for (const [index, error] of error.response.data.message.entries()){
                  this.$vs.notify({
                      color: 'danger',
                      title: 'Error',
                      iconPack: 'feather',
                      icon:'icon-x',
                      text: error
                  })
              }
            });

             this.fetchData()
        },
        confirmPod(row){
          this.selectedOrder = []
            this.data_confirm = {
                enable_arrival:false,
                arrival_time:null,
                receiver_name:'',
                enable_pod:false,
                pod_code_id:null,
                pod_time:null,
                enable_submit_time:false,
                submit_time:null,
                enable_remark:false,
                remark:'',
            }
            this.selectedOrder = row.selected
            this.selectedOrderCount = row.selected.length 
            this.showConfirmPod = true
        },
        cancelPod (row) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Cancel Confirmation',
                text: 'Are you sure want to cancel selected order?',
                accept: function(){
                
                }
            })
        },
        exportTransportNote(){
       this.isLoading = true
         this.$http.get('transport/routeplanning/report/note/'+this.single_manifest.id, { responseType: 'blob'})
        .then(response => {
          var blob = new Blob([response.data], {
            type: 'application/pdf'
          });
       window.open(URL.createObjectURL(blob));
      this.isLoading = false
          // saveAs(blob, 'putaway_list_'+this.selectedIdReport+'.pdf')
      })
      .catch(error => {
        this.isLoading = false
        var reader = new FileReader()
        const globalThis = this
        reader.onload = function() {
          globalThis.isLoading = false
          const object = JSON.parse(reader.result)
          const message = object.message ? object.message : 'Something went wrong.'

          globalThis.$vs.notify({
            color: 'danger',
            title: 'Error',
            iconPack: 'feather',
            icon:'icon-x',
            text: message
          })
        }
        reader.readAsText(error.response.data)
      })
      },
        setVehicle(){
            this.single_manifest.alter_vehicle_id = this.single_manifest.vehicle_id
            this.setAlterVehicle()
        },
        setAlterVehicle(){
            this.single_manifest.driver = this.single_manifest.alter_vehicle_id.driver
            this.single_manifest.phone = this.single_manifest.alter_vehicle_id.phone
            this.single_manifest.transporter_id = this.single_manifest.alter_vehicle_id.transporter
            this.single_manifest.vehicle_type_id = this.single_manifest.alter_vehicle_id.vehicle_type
        },
        updateManifest(){
            this.isLoading = true ;
            let data = Object.assign({},this.single_manifest) 
            console.log(this.single_manifest.status.name)
            data.client_id = this.single_manifest.client_id == null ? null : this.single_manifest.client_id.id
            data.warehouse_id = this.single_manifest.warehouse_id == null ? null : this.single_manifest.warehouse_id.id
            data.vehicle_id = this.single_manifest.vehicle_id.id
            data.alter_vehicle_id = this.single_manifest.alter_vehicle_id.id
            data.origin_id = this.single_manifest.origin_id == null ? null : this.single_manifest.origin_id.id
            data.destination_id = this.single_manifest.destination_id == null ? null : this.single_manifest.destination_id.id
            data.transporter_mode_id = this.single_manifest.transporter_mode_id.id
            data.driver = this.single_manifest.driver
            data.phone = this.single_manifest.phone
            data.vehicle_type_id = this.single_manifest.vehicle_type_id.id
            data.transporter_id = this.single_manifest.transporter_id.id
            this.$http.put('transport/manifest/'+this.single_manifest.id+'/update', data)
            .then((res)=>{
                console.log(data)
                this.isLoading = false;
                this.editMode = false;
                this.showPopupManifest = false;
                this.$vs.notify({
                    color: 'success',
                title: 'Update Success',
                iconPack: 'feather',
                icon:'icon-check',
                text: 'Manifest Succesfully Updated'
            })
            })
            .catch((error)=>{
                console.log(data)
                this.isLoading = false ;
                for (const [index, err] of error.response.data.entries()) {
                    this.$vs.notify({
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-x",
                    text: "" + err
                    });
                }
            })
        },
        discardManifest(){
            this.editMode = false;
            this.single_manifest = Object.assign({}, this.oldManifest) ;
        },
        editManifest(){
            this.isLoading = true;
            if(!this.masterSync){
                this.$http.all([
                this.$http.post('master/clients'), 
                this.$http.post("master/areas"),
                this.$http.post("master/transporters"),
                this.$http.post("master/vehicle"),
                this.$http.post("master/warehouses"),       
                this.$http.post("master/vehicletypes"),
                this.$http.post("master/contracttypes"),
                this.$http.post("master/transportersmode"),
                ])
                .then(
                this.$http.spread(
                    (
                    clients,
                    areas,
                    transporters,
                    vehicles,
                    warehouses,
                    vehicletypes,
                    contracttypes,
                    mode,
                    ) => {
                        this.areaOptions = [];
                        this.areaOptions = areas.data.data;
                        this.clientOption = clients.data;
                        this.transporterOption = transporters.data;
                        this.vehicleOption = vehicles.data.data;
                        this.warehouseOptions = warehouses.data;
                        this.vehicleTypeOption = vehicletypes.data.data;
                        this.contractTypeOption = contracttypes.data.data;
                        this.transporterModeOption = mode.data;
                        setTimeout(() => {
                            this.isLoading = false;
                            this.editMode = true;
                             this.masterSync = true ;
                        }, 500);
                    }
                )
                )
                .catch((error) => {
                    this.isLoading = false;
                    this.masterSync = false ;
                    console.log(error)
                });
            }else{
                this.editMode = true;
                this.isLoading = false;
            }
        },
        viewManifest(id){
            this.isLoading = true ;
            this.editMode = false ;
            this.single_manifest = {
                id:'',
                trip:'',
                schedule_date:'',
                reference:'',
                origin_id:null,
                destination_id:null,
                status:{
                    id:'',
                    name:''},
                client_id:null,
                warehouse_id:null,
                driver:'',
                phone:'',
                vehicle_id:{
                    box_dimension: '',
                    cap_volume: '',
                    cap_weight: '',
                    contract_type_id: null,
                    driver: '',
                    phone: '',
                    transporter_id: null,
                    vehicle_code: '',
                    vehicle_type_id: null,

                },
                load_volume:'',
                load_weight:'',
                load_quantity:'',
                alter_vehicle_id:null,
                transporter_id: null,
                vehicle_type_id:null,
                transporter_mode_id:null,
                container_number:'',
                seal_number:'',
                vessel_number:'',
                voyage_number:'',

            };
            this.$http.get('transport/manifest/'+ id)
            .then(res => {
                this.isLoading = false ;
                this.showPopupManifest = true ;
                this.single_manifest = res.data;
                this.single_manifest.vehicle_id = res.data.vehicle;
                this.single_manifest.alter_vehicle_id = res.data.alter_vehicle;
                this.single_manifest.client_id = res.data.client;
                this.single_manifest.warehouse_id = res.data.warehouse;
                this.single_manifest.origin_id = res.data.origin;
                this.single_manifest.destination_id = res.data.destination;
                this.single_manifest.transporter_mode_id = res.data.transporter_mode;
                
                this.single_manifest.driver = res.data.driver == null ? res.data.vehicle.driver : res.data.driver;
                this.single_manifest.phone = res.data.phone == null ? res.data.vehicle.phone : res.data.phone;

                this.single_manifest.vehicle_type_id = res.data.vehicle_type == null ? res.data.vehicle.vehicle_type : res.data.vehicle_type;
                this.single_manifest.transporter_id = res.data.transporter == null ? res.data.vehicle.transporter : res.data.transporter ;
                this.oldManifest = Object.assign({}, this.single_manifest) ;
                // Object.freeze(this.oldManifest);
            })
            .catch(error => {
                this.isLoading = false ;
                console.log(error);
            })
        },
        viewAttachment(attch){
            this.isLoading = false ;
            this.showPopupAttachment = true ;
            this.attach_name=attch;
        },
        viewPod(id){
            this.isLoading = true ;
            this.editMode = false ;
            this.tro = {
                    id:'',
                    transport_reference:'',
                    req_del_date:'',
                    order_type: '',
                    client_name: '',
                    origin_name: '',
                    origin_address1: '',
                    origin_address2: '',
                    origin_area_name: '',
                    origin_area_subdist: '',
                    destination_address1: '',
                    destination_address2: '',
                    destination_area_name: '',
                    destination_area_subdist: '',
                    transporter_name: '',
                    transporter_service_name: '',
                    transporter_order_details:[],
                },

            
            this.$http.get('transport/transportorder/'+ id)
            .then(res => {
                this.isLoading = false ;
                this.showPopupTro = true ;
                this.tro = res.data.transportorder;
                this.tro.id = res.data.transportorder.id;
                this.tro.reference = res.data.transportorder.transport_reference;
                this.tro.req_del_date = res.data.transportorder.req_del_date;
                this.tro.order_type = res.data.transportorder.order_type.order_type;
                this.tro.client_name = res.data.transportorder.client.name;
                this.tro.origin_name = res.data.transportorder.origin.name;
                this.tro.origin_address1 = res.data.transportorder.origin.address_1;
                this.tro.origin_address2 = res.data.transportorder.origin.address_2;
                this.tro.origin_area_name = res.data.transportorder.origin_area.village;
                this.tro.origin_area_subdist = res.data.transportorder.origin_area.subdistrict;
                this.tro.destination_name = res.data.transportorder.destination.name;
                this.tro.destination_address1 = res.data.transportorder.destination.address_1;
                this.tro.destination_address2 = res.data.transportorder.destination.address_2;
                this.tro.destination_area_name = res.data.transportorder.destination_area.village;
                this.tro.destination_area_subdist = res.data.transportorder.destination_area.subdistrict;
                this.tro.transporter_name = res.data.transportorder.transporter.name;
                this.tro.transporter_service_name = res.data.transportorder.service_type.service_type;
                this.tro.transporter_order_detail = res.data.transportorder_details;
            })
            .catch(error => {
                this.isLoading = false ;
                console.log(error);
            })
        },
        searchArea(search, loading) {
            if(search.length > 2){
                loading(true)
                const data = {
                    name: search
                }
                this.$http.post('master/areas', data)
                .then(res => {
                    this.areaOptions = res.data.data
                    loading(false)
                })
                .catch((error) => {
                    setTimeout(() => {
                        console.log(error)
                        loading(false)
                    }, 5000);
                })
            }
        },
        refreshData() {
            this.maxRetry = 10;
            this.fetchData();
        },
        fetchData() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            this.manifest = [];
            this.$http
                .post("transport/pod?page="+this.currentPage, this.filter)
                .then(res => {
                     let count = res.data.total / res.data.per_page ;
                    this.totalPages = count ;
                    res.data.data.map(item => {
                        this.manifest.push({...item, selected:[]})
                    });
                    this.isLoading = false;
                })
                .catch((error) => {
                    console.log(error)
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.refreshData();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchData();
                });

                if(this.podCodeOption.length <= 0){
                    this.$http.post("master/podcodes")
                    .then(res => {
                        this.podCodeOption = res.data.data
                        this.isLoading = false;
                    })
                    .catch((error) => {
                        console.log(error)
                    });
                }
        },
        exportData() {
            this.isLoading = true;
            this.$http
                .get("inventories/movementorder/report/download_excel", {
                    responseType: "blob"
                })
                .then(res => {
                    this.isLoading = false;
                    FileSaver.saveAs(res.data, "mo_export.xlsx");
                });
        },
        filterData() {
            this.fetchData();
        },
        trackAndTrace(){

        },
        filterInit() {
            if(!this.masterSync){

                this.$http.all([
                this.$http.post("master/customers"),
                this.$http.post('master/clients'), 
                this.$http.post("master/areas"),
                this.$http.post("master/transporters"),
                this.$http.post("master/vehicle"),
                this.$http.post("master/warehouses"),       
                this.$http.post("master/vehicletypes"),
                this.$http.post("master/podcodes"),
                this.$http.post("master/contracttypes"),
                this.$http.post("master/transportersmode"),
                ])
                .then(
                    this.$http.spread(
                        (
                    customer,
                    clients,
                    areas,
                    transporters,
                    vehicles,
                    warehouses,
                    vehicletypes,
                    podcodes,
                    contracttypes,
                    mode,
                    ) => {
                        // this.areaOptions = [];
                        this.ddl_origin.data = customer.data.data;
                        this.ddl_destination.data = customer.data.data;
                        this.ddl_client.data = clients.data.data;
                        this.ddl_transporter = transporters.data;
                        this.ddl_vehicle.data = vehicles.data.data;
                        this.ddl_podcodes.data = podcodes.data.data;

                        this.ddl_origin.data.unshift({
                            id: null,
                            name: 'Any'
                        })
                        this.ddl_destination.data.unshift({
                            id: null,
                            name: 'Any'
                        })
                        this.ddl_client.data.unshift({
                            id: null,
                            client_code: 'Any'
                        })
                        this.ddl_transporter.data.unshift({
                            id: null,
                            transporter_code: 'Any'
                        })
                        this.ddl_vehicle.data.unshift({
                            id: null,
                            vehicle_code: 'Any'
                        })
                        this.ddl_podcodes.data.unshift({
                            id: null,
                            pod_code: 'Any'
                        })
                        this.masterSync = true ;
                        // this.warehouseOptions = warehouses.data;
                        // this.vehicleTypeOption = vehicletypes.data.data;
                        // this.contractTypeOption = contracttypes.data.data;
                        // this.transporterModeOption = mode.data;
                        setTimeout(() => {
                            this.showFilter = true;
                        }, 500);
                    }
                )
                )
                .catch((error) => {
                    this.isLoading = false;
                    this.masterSync = false ;
                    console.log(error)
                });
            }else{
                setTimeout(() => {
                    this.showFilter = true;
                }, 500);
            }
        }
    },
    mounted() {
        this.filterData()
        // this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
    }
}
</script>

<style type="text/css">
    #my-collapse .vs-collapse-item--header {
        font-size: 1rem;
        padding: 1rem;
    }
    #routedOrder .vs-table--tbody-table .tr-values td {
        padding: 4px 6px;
    }
    .con-vs-dropdown--menu {
        z-index: 99999;
    }
    #myPopup.con-vs-popup .vs-popup {
        width: 1200px;
    }
    #myTropoppup.con-vs-popup .vs-popup {
        width: 1200px;
    }
    #myAttachpoppup.con-vs-popup .vs-popup {
        width: 400px;
    }
</style>
